
import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux';
import { useEvent } from './useEvent';
import * as ActionTypes from '../actions/actionTypes'
import { SAVE_ITEM_CDS } from '../api/apiEvents';

export const useMultipleInvoiceItem=({tableName,invoiceId})=>{
 const {isLoading,saveForm,deleteForm}=useEvent("invoice",true)
 const dispatch = useDispatch();
  const AddItem = useCallback(async(callback) => {
     try{
       
        const response=await saveForm({
            "invoiceList": {
                [`${invoiceId}`]: {
                    [`${tableName}`]: [
                        tableName=="additionalFiscalReferences" ? {"frRoleCode":"FR1"}:{}
                    ]
                }
            }
        },true,SAVE_ITEM_CDS)

     

        if(response){
        dispatch({
            type: ActionTypes.ADD_INVOICE_DOC_BY_ID,
            payload:{response:response.invoice.invoiceList[invoiceId][tableName][0],invoiceId},
            meta:{tableName}
        })
        callback && callback(response)
    }
     }
     catch(e){

     }
  }, [invoiceId]);

  const deleteItem = useCallback(async(id) => {
    try{
         const response=await deleteForm( {"invoiceList": {[`${invoiceId}`]: { [`${tableName}`]:[{id}]}}})
         if(response)
        dispatch({ type:ActionTypes.DELETE_INVOICE_DOC_BY_ID,payload:{id,invoiceId},meta:{tableName:tableName}}) 
      
     }
     catch(e){

     }
 }, [
    invoiceId
]);

 const updateItem = useCallback((id,payload) => {
    try{
        dispatch({
            type:ActionTypes.UPDATE_INVOICE_DOC_BY_ID,
            id,
            payload:{...payload, invoiceId},
            meta:{tableName:tableName}
        })
    }
    catch{

    }
 }, []);

 const saveItem = useCallback(async(payload) => {
    try{


        const response=await saveForm({
            "invoiceList": {
                [`${invoiceId}`]: {
                    [`${tableName}`]: Array.isArray(payload) ? payload: [payload]
                }
            }
        },false,SAVE_ITEM_CDS)
    
    }
    catch{

    }
 }, []);



  return React.useMemo(()=>({AddItem,deleteItem,updateItem,saveItem,isLoading}),[AddItem,deleteItem,updateItem,saveItem,isLoading])
}